import React, { useState, useEffect } from 'react';
import { Box, Grid, TablePagination, Typography } from '@mui/material';
import { AdminTable, ListViewProps } from '../components';
import useAPI from '../../utils/useApi';
import { ListResource, RequestInput } from '../../types';

export const RelatedList = (props: ListViewProps) => {
  const [rows, setRows] = useState<{ [name: string]: string }[]>();
  const [totalRows, setTotalRows] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);

  let dataList = useAPI<ListResource>(props.apiRequest);

  useEffect(() => {
    if (props.recordid) {
      let queryParams: { [name: string]: string } = {
        q: `${props.relatedFilter}=${props.recordid}`,
      };
      queryParams['page'] = `${currentPage}`;
      const req: RequestInput = {
        queryParams: queryParams,
      };

      dataList.execute(req);
    }
  }, [currentPage, props.recordid]);

  useEffect(() => {
    if (dataList.data) {
      console.log(dataList.data);
      setRows(dataList.data.records);
      setTotalRows(dataList.data.total);
    }
  }, [dataList.data]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage);
  };

  const tableProps = {
    ...props.tableProps,
    columns: props.tableProps.columns || [],
    rows: rows,
    emptyMessage: <Typography>No {props.title} found </Typography>,
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <Typography variant="h5" sx={{ px: 2, pt: 6 }}>
          {props.title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box display="flex" justifyContent="flex-end">
          {props.actions?.map((action: JSX.Element) => {
            return action;
          })}
        </Box>
      </Grid>
      <Grid container justifyContent="right">
        <TablePagination
          count={totalRows}
          onPageChange={handlePageChange}
          page={currentPage}
          rowsPerPage={100}
          rowsPerPageOptions={[100]}
        />
      </Grid>
      <Grid item xs={12}>
        <AdminTable {...tableProps} />
      </Grid>
    </Grid>
  );
};
